import { createContext, useContext } from 'react';
import { IImpersonatedUser } from './types';

interface IImpersonationContext {
  impersonatedUser: IImpersonatedUser | null;
  startImpersonation: (userId: number) => Promise<void>;
  endImpersonation: () => Promise<void>;
}

export const ImpersonationContext = createContext<IImpersonationContext>({
  impersonatedUser: null,
  startImpersonation: async () => {},
  endImpersonation: async () => {},
});

export const useImpersonationContext = () => {
  const context = useContext(ImpersonationContext);
  if (!context) {
    throw new Error(
      'useImpersonation must be used within an ImpersonationProvider'
    );
  }
  return context;
};
